import { useState } from 'react';
import NvSelect, { SelectOption } from 'shared/components/inputs/nv-select';

type DropdownQuestionProps = {
  title: string;
  answer: string;
  options: SelectOption[];
  className?: string,
  placeholder: string;
  onChange: (answer: string) => void;
  dataQa?: string;
  dataQaId?: string;
  ariaLabel?: string;
  renderFallbackValue?: boolean;
};
const DropdownQuestion = ({ title, answer, options, className, onChange, placeholder, dataQa, dataQaId, ariaLabel, renderFallbackValue }: DropdownQuestionProps) => {
  const [value, setValue] = useState(answer);

  const handleChange = (newValue: string) => {
    setValue(newValue);
    onChange(newValue);
  };

  return (
    <div
      className={`w-100 d-flex flex-column ${className}`}
      data-qa={dataQa}
      data-qa-id={dataQaId}
    >
      <span className='input-label text-regular semi-bold'>{title}</span>
      <NvSelect
        value={value}
        options={options}
        className='select-dropdown'
        onChange={handleChange}
        placeholder={placeholder}
        ariaLabel={ariaLabel}
        renderFallbackValue={renderFallbackValue}
      />
    </div>
  );
};

export default DropdownQuestion;
